import React, { useEffect } from 'react';
import SuccessImg from '../../../assets/trial_images/success.png';
import { Countdown } from './Countdown';
const TrialSuccess = (props) => {
  const { callBackPageFun } = props;
  let sec = Countdown(5);

  useEffect(() => {
    if (sec === 0) {
      callBackPageFun();
    }
  }, [sec]);

  return (
    <div className="trial_success">
      <img className="trial_success_img" src={SuccessImg} />
      <div className="trial_success_text">
        已收到您的业务需求，我们的业务员会尽快联系您
      </div>
      <div className="trial_success_countdown">
        {sec}
        <span>秒后关闭当前页面</span>
      </div>
    </div>
  );
};
export default TrialSuccess;
